import memoizeOne from "memoize-one";
import { Iterable, List, Map } from "immutable";
import { IGridItem, IDefaultItem, Kinds, ItemFields } from "constants/product-collection";
import {
    ISchemaKey,
    getItemValueByType,
    convertDefaultItemToItem,
    setItemValueByType,
} from "helpers/product-collection";
import { amphibiousGet } from "helpers/objUtils";

const isEmptyValue = (value) => {
    if (typeof value === "string") {
        return !value.trim();
    }

    return value === undefined || value === null;
};

export const populateDefaultItem = (
    item: IGridItem,
    defaultItem: IDefaultItem,
    itemDisplayProperties: List<ISchemaKey> | Array<ISchemaKey>[]
) => {
    const convertedDefaultItem = convertDefaultItemToItem(defaultItem);
    // Loop through available fields.
    (Iterable.isIterable(itemDisplayProperties)
        ? (itemDisplayProperties as List<ISchemaKey>).toJS()
        : itemDisplayProperties
    ).forEach((itemDisplayProperty) => {
        const defaultValue = getItemValueByType(
            convertedDefaultItem,
            itemDisplayProperty.field_name,
            itemDisplayProperty.value_type
        );
        if (
            // check if there is default value.
            !isEmptyValue(defaultValue) &&
            // If current field is empty, populate it.
            isEmptyValue(getItemValueByType(item, itemDisplayProperty.field_name, itemDisplayProperty.value_type))
        ) {
            setItemValueByType(item, itemDisplayProperty.field_name, defaultValue, itemDisplayProperty.value_type);
        }
    });

    return item;
};

const getImageFieldKeys = memoizeOne((itemDisplayProperties: List<ISchemaKey> | Array<ISchemaKey>[]) => {
    const schemaKeys = [];

    itemDisplayProperties.forEach((schema) => {
        if (amphibiousGet(schema, "kind") === Kinds.IMAGE_URL) {
            schemaKeys.push(amphibiousGet(schema, "field_name"));
        }
    });

    return schemaKeys;
});
export const filterOutProtectedKeys = (
    defaultItem: Map<string, any>,
    itemDisplayProperties: List<ISchemaKey> | Array<ISchemaKey>[]
) => {
    let mutatedItem = defaultItem;
    const imageKeys = getImageFieldKeys(itemDisplayProperties);

    Array.from(defaultItem.get(ItemFields.Fields).keys()).forEach((key: string) => {
        // Internal field starts with _
        // Image shouldn't be able to default-able
        if (key.match(/^_/) || imageKeys.includes(key)) {
            mutatedItem = mutatedItem.deleteIn([ItemFields.Fields, key]);
        }
    });

    return mutatedItem;
};
